<template>
  <div class="drawer">
    <el-drawer
      size="450px"
      title="退洗美卡"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <!-- <img src="../../../../assets/img/remark.png" class="avatar"/> -->
      <el-form :inline="true" class="form">
        <el-row class="row">
          <el-col :span="20" :offset="1">
            <el-form-item
              label="卡片名称:"
              :label-width="formLabelWidth"
              class="formItem"
            >
              <div style="display: inline-block; width: 253px">
                {{ curItem.card_name }} ({{ curItem.service_name }}-{{
                  curItem.service_object_name
                }})
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="20" :offset="1">
            <el-form-item
              label="卡片编号:"
              :label-width="formLabelWidth"
              class="formItem"
            >
              {{ curItem.card_number }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="20" :offset="1">
            <el-form-item
              label="剩余次数:"
              :label-width="formLabelWidth"
              class="formItem"
            >
              {{ curItem.surplus_count }}/{{ curItem.total_count }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="20" :offset="1">
            <el-form-item
              label="退还金额:"
              :label-width="formLabelWidth"
              class="formItem"
            >
              <el-input
                @change="refundMoney"
                v-model="money"
                @input="inputPrice"
                size="small"
                style="width: 120px; padding-top: 4px"
              >
                <template slot="append">元</template>
                <!-- v-if=curItem.surplus_count==curItem.total_count -->
              </el-input>
              最高退款金额：
              <span>
                {{
                  curItem.surplus_count == curItem.total_count
                    ? $public.cheng_2(curItem.surplus_count, curItem.unit_price)
                    : $public.cheng(curItem.surplus_count, curItem.unit_price)
                }}
              </span>
              元
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="20" :offset="1">
            <el-form-item
              label="退卡备注:"
              :label-width="formLabelWidth"
              class="formItem"
            >
              <el-input
                type="textarea"
                v-model="remark"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="20" :offset="1">
            <el-form-item
              label="结算方式:"
              :label-width="formLabelWidth"
              class="formItem"
            >
              <span v-for="item in payList" :key="item.id">
                {{ $public.formatPayTypeState(item.pay_type) }} {{ item.money }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="msgBox" v-if="isReturnYuE">
          <div style="margin-left: 50px; vertical-align: middle">
            <div class="msgBoxL">收款人姓名:</div>
            <el-input
              v-model="returnAccountParam.name"
              placeholder="请输入收款人姓名"
            ></el-input>

            <div class="msgBoxL">开户行:</div>
            <el-input
              v-model="returnAccountParam.bank_name"
              placeholder="请输入开户行信息"
            ></el-input>

            <div class="msgBoxL">银行卡号:</div>
            <el-input
              v-model="returnAccountParam.card_no"
              placeholder="请输入卡号"
            ></el-input>
          </div>
        </div>
      </el-form>
      <div style="height: 40px; width: 100%"></div>
      <div class="btnBox">
        <div class="btnItem" @click="handleClose">取消</div>
        <div class="btnItem submit" @click="submitCode">确定</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payList: [],
      returnMoney1: "",
      isReturnYuE: false,
      drawerStatus: true,
      formLabelWidth: "80px",
      money: "",
      remark: "",
      // 收款
      returnAccountParam: {
        name: "", //姓名
        bank_name: "", //开户行
        card_no: "",
      },
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
  },
  props: {
    curItem: {
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    console.log(this.curItem, "curItem");
  },
  methods: {
    //input失去焦点的时候获取结算方式
    refundMoney(a) {
      // console.log("input失去焦点", a);
      let money = this.curItem.surplus_count == this.curItem.total_count
                    ? this.$public.cheng_2(this.curItem.surplus_count, this.curItem.unit_price)
                    : this.$public.cheng(this.curItem.surplus_count, this.curItem.unit_price);
      if (
        !this.$public.isNull(a) &&
        a <=
        money
      ) {
        console.log("判断成功");
      } else {
        this.$message({
          message: "退款金额输入有误！！",
          type: "error",
        });
        return;
      }
      let loading = this.$loading();
      let params = {
        cardNumber: this.curItem.card_number, // 退款卡号
        return_price: a, // 退款金额
        price: this.curItem.unit_price, //单价
        count: this.curItem.surplus_count, // 退款次数
        orderNo: this.curItem.source_order_no, // 原订单号
      };
      this.$http
        .post("/api/ReturnOrder/CalculateCardRefund", params)
        .then((res) => {
          console.log("退款返回的参数", res);
          loading.close();
          if (res.code == 0) {
            this.payList = res.data.payList;
            this.returnMoney1 = res.data.returnMoney;
            res.data.payList.forEach((item) => {
              if (item.pay_type == 6 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 7 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 8 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 9 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 10 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 12 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 14 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 16 && item.money !== 0) {
                this.isReturnYuE = false;
              }
            });
          }
        });
    },
    handleClose() {
      this.$emit("submit", { type: "close" });
    },
    inputPrice() {
      this.money = this.$public.replaceGoodsDosage(this.money);
    },
    submitCode() {
      let money = this.curItem.surplus_count == this.curItem.total_count
                    ? this.$public.cheng_2(this.curItem.surplus_count, this.curItem.unit_price)
                    : this.$public.cheng(this.curItem.surplus_count, this.curItem.unit_price);
      if (
        !this.$public.isNull(this.money) &&
        this.money <=
        money
      ) {
        console.log("判断成功");
      } else {
        this.$message({
          message: "退款金额输入有误！！",
          type: "error",
        });
        return;
      }
      if (this.remark.length < 20) {
        this.$message({
          type: "error",
          message: "退款备注不少于20字",
        });
        return;
      }
      let params = {
        cardNumber: this.curItem.card_number, // 退款卡号
        goodsId: this.curItem.service_id, // 虚拟卡id
        goodsName: this.curItem.service_name, // 虚拟卡名字
        skuId: this.curItem.service_object_id, // 规格id
        skuValue: this.curItem.service_object_name, // 规格名字
        price: this.curItem.unit_price, //单价
        count: this.curItem.surplus_count, // 退款次数
        remark: this.remark, // 退款备注
        userId: this.userInfo._id, // 用户id
        userName: this.userInfo.basic_info.nick_name, // 用户名
        userMobile: this.userInfo.basic_info.user_mobile, // 手机号
        orderNo: this.curItem.source_order_no, // 原订单号
        return_price: Number(this.money),
        returnAccountParam: this.returnAccountParam,
      };
      let loading = this.$loading();
      this.$http
        .post("/api/ReturnOrder/ShowerCardRefund", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // this.$emit("submit", { type: "success", order: res.data });
            this.$emit("submit");
            this.$router.go(0);
            // console.log('页面刷新了');
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.msgBox {
  display: flex;
  // padding: 20px;
  margin-bottom: 10px;
  & > span {
    display: inline-block;
    padding: 20px;
    text-align: right;
  }
}
.msgV {
  line-height: 54px;
}
.msgBoxL {
  height: 56px;
  line-height: 56px;
}
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .avatar {
      width: 200px;
      display: block;
      margin: 80px auto 80px;
    }
    .form {
      ::v-deep .el-form-item {
        margin: 5px 0;
      }
      .row {
        float: none;
        border-bottom: 1px solid #f2f2f2;
        padding: 3px 0;
        .formItem {
          margin: 0;
        }
      }
    }
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;
  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;
    &.submit {
      background-color: $mainColor;
    }
  }
}
</style>
